import { useMemo } from "react";
import { ConnectorClient } from "services";

export const useConnector = (args = {}) => {
  return useMemo(() => ConnectorClient(args), []);
};
